import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconUserComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <path
        d="M15.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0zM4.4 20.1a7.5 7.5 0 0 1 15 0 18 18 0 0 1-7.5 1.6 18 18 0 0 1-7.5-1.6z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};

IconUserComponent.displayName = 'IconUser';

const IconUser = memo(IconUserComponent);

export default IconUser;
